import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { MatDrawer } from '@angular/material/sidenav';
import { MatDialog } from "@angular/material/dialog";
import { QuestionGroupsService } from "../question-groups.service";
import { QuestionGroup } from "../../shared/models/question-group.model";
import { CreateQuestionGroupPanelOptions } from "../question-groups-list-options.enum";
import CreateQuestionGroup = CreateQuestionGroupPanelOptions.CreateQuestionGroup;
import EditQuestionGroup = CreateQuestionGroupPanelOptions.EditQuestionGroup;
import CreateQuestion = CreateQuestionGroupPanelOptions.CreateQuestion;
import EditQuestion = CreateQuestionGroupPanelOptions.EditQuestion;
import None = CreateQuestionGroupPanelOptions.None;
import { FeedbackService } from "../../shared/services/feedback.service";
import { ConfirmDialogComponent } from "../../shared/confirm-dialog/confirm-dialog.component";
import { YesNo } from "../../shared/enums/yes-no.enum";
import * as _ from "lodash";
import { takeUntil, catchError, tap } from 'rxjs/operators';
import { Subject, of, forkJoin } from 'rxjs';


@Component({
  selector: "app-question-groups-list",
  templateUrl: "./question-groups-list.component.html",
  styleUrls: ["./question-groups-list.component.scss"],
  providers: [QuestionGroupsService, FeedbackService],
})
export class QuestionGroupsListComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild("Drawer", { static: false }) drawer: MatDrawer;
  currentPanelOptions: CreateQuestionGroupPanelOptions;
  isLoading: boolean;
  questionGroups: QuestionGroup[];
  questionGroupId: number;
  questionId: number;

  constructor(
    private questionGroupService: QuestionGroupsService,
    private feedbackService: FeedbackService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getAllQuestionGroups();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  drop(event: any, group: QuestionGroup) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(
        group.questionGroupQuestions,
        event.previousIndex,
        event.currentIndex
      );

      for (let i = 0; i < group.questionGroupQuestions.length; i++) {
        group.questionGroupQuestions[i].index = i + 1;
      }

      this.isLoading = true;
      this.questionGroupService.updateQuestionGroup(group).pipe(
        tap(() => {
          this.feedbackService.success("Question order saved");
        }),
        catchError((error) => {
          this.feedbackService.error("An error occurred while saving the question order");
          return of(null);
        })
      ).subscribe();
    }
  }

  createQuestionGroup() {
    this.currentPanelOptions = CreateQuestionGroup;
    this.drawer.open();
  }

  editQuestionGroup(questionGroupId: number) {
    console.log("QGLC - at editQuestionGroup");
    this.currentPanelOptions = EditQuestionGroup;
    this.questionGroupId = questionGroupId;
    this.drawer.open();
  }

  addQuestionToQuestionGroup(questionGroupId: number) {
    console.log("QGLC - at addQuestionToQuestionGroup");
    this.currentPanelOptions = CreateQuestion;
    this.questionGroupId = questionGroupId;
    this.drawer.open();
  }

  editQuestion(questionId: number, questionGroupId: number) {
    console.log("QGLC - at editQuestion");
    this.currentPanelOptions = EditQuestion;
    this.questionGroupId = questionGroupId;
    console.log("QGLC - at editQuestion - ", this.questionGroupId);
    this.questionId = questionId;
    console.log("QGLC - at editQuestion - ", this.questionId);
    this.drawer.open();
  }

  deleteQuestionFromQuestionGroup(questionId: number, questionGroupId: number) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: {
        title: name,
        message: `Are you sure you want to delete this question from the question group?`,
      },
    });

    dialogRef.afterClosed().pipe(
      takeUntil(this.destroy$),
      tap((result: YesNo) => {
        if (result === YesNo.Yes) {
          this.questionGroupService.deleteQuestionFromQuestionGroup(questionGroupId, questionId).pipe(
            takeUntil(this.destroy$),
            tap((response) => {
              if (response) {
                this.getAllQuestionGroups();
                this.drawer.close();
                this.feedbackService.success("Question deleted from question group");
              }
            }),
            catchError(() => {
              this.feedbackService.error("An error occurred while deleting the record");
              return [];
            })
          ).subscribe();
        } else {
          this.dialog.closeAll();
        }
      })
    ).subscribe();
  }

  deleteQuestionGroup(questionGroupId: number) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "250px",
      data: {
        title: name,
        message: `Are you sure you want to delete this question group?`,
      },
    });

    dialogRef.afterClosed().pipe(
      takeUntil(this.destroy$),
      tap((result: YesNo) => {
        if (result === YesNo.Yes) {
          this.questionGroupService.deleteQuestionGroup(questionGroupId).pipe(
            takeUntil(this.destroy$),
            tap((response) => {
              if (response) {
                this.getAllQuestionGroups();
                this.drawer.close();
                this.feedbackService.success("Question group deleted");
              }
            }),
            catchError(() => {
              this.feedbackService.error("An error occurred while deleting the record");
              return [];
            })
          ).subscribe();
        } else {
          this.dialog.closeAll();
        }
      })
    ).subscribe();
  }

  closeDrawer() {
    this.currentPanelOptions = None;
    this.drawer.close();
    this.getAllQuestionGroups();
  }

  getNewQuestionIndex(questionGroupId: number) {

    const qg = this.questionGroups.find(a => a.questionGroupId === questionGroupId);
    if (qg) {
      return qg.questionGroupQuestions.length + 1;
    }

    return 0;
  }

  private getAllQuestionGroups() {
    this.isLoading = true;
    this.questionGroupService.getAllQuestionGroups().pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (response) => {
        if (response) {
          this.questionGroups = response;
          this.questionGroups.forEach((questionGroup) => {
            questionGroup.questionGroupQuestions = _.sortBy(
              questionGroup.questionGroupQuestions,
              ["index"],
              ["asc"]
            );
          });
        }
      },
      error: (error) => {
        this.feedbackService.error(error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
}
